var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirtstTimePerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "60px",
    viewBox: "0 0 68 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AD890234-C6AC-4A3A-81AD-BE6544746C80") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "35.-Part-2---starting-hana-UI",
    transform: "translate(-358.000000, -278.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(358.000000, 279.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "First-time-supply",
    fontFamily: "Gotham-Bold, Gotham",
    fontSize: 7.83999987,
    fontWeight: "bold",
    letterSpacing: 0.00139999988,
    fill: "#222456"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 56.526189
  }, "First-time supply")), /*#__PURE__*/React.createElement("path", {
    d: "M46.9547532,12.5455538 C46.9547532,19.4742937 41.3379533,25.0910936 34.4092134,25.0910936 C27.4804735,25.0910936 21.8636736,19.4742937 21.8636736,12.5455538 C21.8636736,5.6169539 27.4804735,0.000153999997 34.4092134,0.000153999997 C41.3379533,0.000153999997 46.9547532,5.6169539 46.9547532,12.5455538 Z",
    id: "Stroke-2",
    stroke: "#EE7330",
    strokeWidth: 1.95999997
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0154218,46.4848852 C13.0154218,34.6694454 22.5938016,25.0912056 34.4092414,25.0912056 C46.2246812,25.0912056 55.803061,34.6694454 55.803061,46.4848852",
    id: "Stroke-3",
    stroke: "#222456",
    strokeWidth: 1.95999997
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirtstTimePerson);
export default __webpack_public_path__ + "static/media/firtstTimePerson.f0becf54.svg";
export { ForwardRef as ReactComponent };